export const TpoDenialTreeItemType = {
  CATEGORY: 'category',
  REASON: 'reason',
};
